<template>
    <div>
        <ButtonSelectField
            :options="fields.options"
            :selected="selected"
            :name="name"
            :validationRules="validationRules"
            buttonClasses="wizard-button"
        />
    </div>
</template>

<script>
import { useStore } from 'vuex'

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'maritalStatus',
            hideContinue: true,
            route: {
                relativeUrl: `marital-status`,
                name: 'apply.maritalStatus',
                meta: {
                    title: 'form.sections.aboutYou.maritalStatus.heading',
                    layoutType: 'large',
                },
            },
            fields: {
                maritalStatus: {
                    value: null,
                    mappedKey: 'marital_status',
                    formatterOnQuery: 'numericFormatter',
                    validationRules: {
                        required: true,
                    },
                },
            },
        }
    },

    data() {
        return {
            name: 'maritalStatus',
            fields: {
                options: [],
            },
        }
    },
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    created() {
        this.emitter.emit('stepLoaded')

        this.fields.options = this.$i18n.messages[this.$i18n.locale].form.fields.maritalStatus.options
    },
    mounted() {
        if (this.value) {
            this.store.dispatch('updateStepSetting', {
                setting: 'hideContinue',
                settingValue: false,
                step: this.store.state.apply.currentRouteStep,
            })
        }
    },
    computed: {
        value: function () {
            return this.store.getters.fieldValue(this.name)
        },
        validationRules: function () {
            return this.store.getters.fieldValidationRules(this.name)
        },
    },
    methods: {
        selected: function (values) {
            this.emitter.emit('nextStep')
        },
    },
}
</script>
